/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ReportTemplateSectionType from '@linc-technologies/linced-common/enums/reports/report-template-section-type';
import type ReportTemplate from '@linc-technologies/linced-common/models/reports/report-template';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: reports.ReportTemplateSection.
export default class ReportTemplateSection extends Model {
  declare [Type]: 'reports/report-template-section';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @belongsTo('reports/report-template', { async: true, inverse: null })
  declare reportTemplateId: AsyncBelongsTo<ReportTemplate>;

  @alias('reportTemplateId')
  declare reportTemplate: AsyncBelongsTo<ReportTemplate>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('number', { defaultValue: 0 })
  declare sectionType: EnumValue<typeof ReportTemplateSectionType>;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare icon: string;

  @attr()
  declare configuration: unknown;

  // Id of the superseding section version, if any (mirrors report-template).
  @attr('string', { defaultValue: '' })
  declare next: string;
}
